import {
  Avatar,
  ListItemText,
  ListItemButton,
  ListItemAvatar,
  Box,
  Stack,
  Grid,
} from "@mui/material";
import { InvestmentStatusTag } from "components/ui/atoms/Tag";
import DealSharings from "models/sharings/DealSharings";
import { LabelValueForText } from "components/ui/atoms/LabelValue";
import ApartmentSharpIcon from "@mui/icons-material/ApartmentSharp";
import LimitedTextBox from "components/ui/atoms/LimitedTextBox";
import OverflowTip from "components/ui/atoms/OverflowTip";

const DealListItemForSharing = ({ deal, onClick }) => {
  return (
    <ListItemButton
      onClick={() => onClick(deal.id)}
      sx={{ flexWrap: { xs: "wrap", md: "nowrap" } }}
    >
      <ListItemAvatar>
        <Avatar
          src={`http://logo.clearbit.com/${deal.company_detail.best_domain}`}
        >
          <ApartmentSharpIcon />
        </Avatar>
      </ListItemAvatar>
      <Stack
        direction={{ xs: "row", md: "column" }}
        alignItems={{ xs: "center", md: "start" }}
        spacing={0}
        sx={{
          width: { xs: "calc(100% - 56px)", md: "20%" },
          maxWidth: { xs: "auto", md: "250px" },
          flexGrow: 0,
          flexShrink: 0,
        }}
      >
        <ListItemText
          primary={<OverflowTip>{deal.company_detail.best_name}</OverflowTip>}
          secondary={
            <>
              {deal.deal_flow_detail.short_name}
              {" - "}
              {deal?.deal_owner_detail?.initials}{" "}
              {deal?.deal_owner_detail?.initials &&
              deal?.secondary_owner_detail?.initials
                ? ", " + deal?.secondary_owner_detail?.initials
                : null}
            </>
          }
        />
        <InvestmentStatusTag status={deal.investment_status} />
      </Stack>
      <Box
        sx={{
          width: { xs: "100%", md: "40%" },
          ml: { xs: 0, md: 2 },
          alignSelf: "stretch",
        }}
      >
        <LimitedTextBox
          title="Description"
          content={deal.company_detail?.description}
          limit={5}
        />
      </Box>
      <Box
        sx={{
          width: { xs: "100%", md: "40%" },
          maxWidth: { md: 500 },
          ml: { xs: 0, md: 2 },
          flexShrink: 0,
          flexGrow: 0,
        }}
      >
        <Grid container spacing={{ xs: 0, md: 3 }} p={0}>
          <Grid size={{ xs: 12, md: 6 }}>
            <LabelValueForText
              label="Created at:"
              value={`${new Date(deal.created_at).toLocaleDateString("fr")}`}
              variant="ForListItem"
            />
            <LabelValueForText
              label="Revenue:"
              value={`${deal.reference_revenue}`}
              isMissing={!deal.reference_revenue}
              variant="ForListItem"
            />
            <LabelValueForText
              label="Requested amount:"
              value={`${deal.requested_amount}`}
              isMissing={!deal.requested_amount}
              variant="ForListItem"
            />
            <LabelValueForText
              label="Round:"
              value={`${deal.investment_round}`}
              isMissing={!deal.investment_round}
              variant="ForListItem"
            />
            <LabelValueForText
              label="Profitable:"
              value={`${
                deal.profitable === false
                  ? "Non"
                  : deal.profitable === true
                  ? "Oui"
                  : "unknown"
              }`}
              isMissing={deal.profitable !== true && deal.profitable !== false}
              variant="ForListItem"
            />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <DealSharings deal={deal} />
          </Grid>
        </Grid>
      </Box>
    </ListItemButton>
  );
};

export default DealListItemForSharing;
